// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#payout-value[data-v-24bbe9dd]  .el-tabs__header.is-top{\n  width: calc(100% - 90px);\n  position: absolute;\n  top: 115px;\n  left: 46px;\n}\n\n", ""]);
// Exports
module.exports = exports;
